import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalConstants } from 'src/app/common/constants/global.constant';
import { QrCodeService } from 'src/app/core/services/qr-input-service/qr-input.service';
import { QrConstants } from 'src/app/core/services/qr-input-service/qr.constants';
import { PcSpecsService } from 'src/app/modules/details-page/services/pc-specs/pc-specs.service';
import { LibraryV2DataService } from 'src/app/core/services/library-v2/library-v2-data.service';
import { GoogleAnalyticsService } from 'src/app/core/services/google-analytics-service/google-analytics.service';
@Component({
  selector: 'app-panther-lake-specs-page',
  templateUrl: './panther-lake-specs-page.component.html',
  styleUrls: ['./panther-lake-specs-page.component.scss'],
})
export class PantherLakeSpecsPageComponent implements OnInit {
  ptlSpcesData: any;
  setFontIntelDisplayOne: boolean;
  ptlType: string;
  isArcGraphics: boolean= false;
  isSecondaryArcGraphics: boolean= false;  
  factTag:any;
  currentExpandedSpec: string | null = null; 
  this_PC : string = ""; 
  nameOrder: string[] = ['processor', 'graphics','graphicsCard', 'os', 'memory', 'storage', 'display', 'wifi','connectivity', 'battery', 'device-type'];
  direction:string;

  constructor(
    private pcSpecsService: PcSpecsService,
    private qrCodeService: QrCodeService,
    private router: Router,
    private googleAnalyticsService: GoogleAnalyticsService,
    private libraryService: LibraryV2DataService    
  ) {}

  ngOnInit(): void {
    this.setFontIntelDisplayOne = this.qrCodeService?.setenusLang();
    const devType = this.qrCodeService.specsDeviceType;
    const currentLanguage: string = this.qrCodeService.qrInput.Language;
    this.direction = (currentLanguage === 'ar-sa' || currentLanguage === 'he') ? 'rtl' : 'ltr';
    this.pcSpecsService.pcSpecsData.subscribe((data) => {
      if (this.qrCodeService?.isPantherLakeStd) {
        this.ptlType = GlobalConstants.PANTHER_LAKE;
      } else if (this.qrCodeService?.isPantherLake12Xe) {
        this.ptlType = GlobalConstants.PANTHER_LAKE_12XE;
      } else if (this.qrCodeService?.isPantherLakeGaming) {
        this.ptlType = GlobalConstants.PANTHER_LAKE_GAMING;
      }else if (this.qrCodeService?.isWildCatLakeStd) {
        this.ptlType = GlobalConstants.WILDCAT_LAKE_STD;
      }

      const isArcGraphic = (badge: string = ''): boolean => {
        return (QrConstants.ARC_GRAPHICS.includes(badge) || ['A', 'B'].includes(badge.charAt(0))
        );
      };

      this.isArcGraphics = isArcGraphic(
        this.qrCodeService.qrInput?.GraphicsBadge
      );

      this.isSecondaryArcGraphics = isArcGraphic(
        this.qrCodeService.qrInput?.SecondaryGraphicsBadge
      );

      this.ptlSpcesData = data;
      this.ptlSpcesData = this.ptlSpcesData.map((item) => ({
        ...item,
        ...(GlobalConstants.PTL_FACTTAGS.find(
          (o) => o.name === item.name
        ) || {}),
      }));

      for (let item of this.ptlSpcesData) {
        if (item.name === 'graphics') {
          if (!this.isArcGraphics) {
            let graphicsObj = GlobalConstants.PTL_FACTTAGS.find(
              (g) => g.name === 'dedicated_graphics'
            );
            if (graphicsObj) {
              item.iconImage = graphicsObj.iconImage;
            }
          }
        }
        if (item.name === 'graphicsCard') {
          if (!this.isSecondaryArcGraphics) {
            let graphicsObj = GlobalConstants.PTL_FACTTAGS.find(
              (g) => g.name === 'dedicated_graphics'
            );
            if (graphicsObj) {
              item.iconImage = graphicsObj.iconImage;
            }
          }
        }
      }  
        const ordered = this.nameOrder.map(name => this.ptlSpcesData.find(item => item.name === name)).filter(Boolean);
        const unordered = this.ptlSpcesData.filter(item => !this.nameOrder.includes(item.name));        
        const deviceObj = {name: 'device-type',title:this.libraryService.getStaticText('tr_deviceType'),iconImage: 'assets/images/ptl12xe_device_specs_icon.svg',gotoImage: 'assets/images/ptl12xe_goto_arrow_icon.svg',description :(devType === 'L')? this.libraryService.getStaticText('tr_laptop') :(devType === 'D')? this.libraryService.getStaticText('tr_desktop'):(devType === 'A')?this.libraryService.getStaticText('tr_Allinone'):this.libraryService.getStaticText('tr_2in1') }
        this.ptlSpcesData = [...ordered,...unordered,deviceObj];  
    });  
  }

  
  routeToTileDetailsPage(tileUrl: string) {
    if (tileUrl !== 'device-type') {
      this.googleAnalyticsService.factTagAnalytics(tileUrl, GlobalConstants.FACTTAG); // II-3852
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate(['/specs/' + tileUrl]);
      });
    }
  }

}
